import { Pipe, PipeTransform } from '@angular/core';
import { UserRole } from '../models/user/user-role.enum';
import { AuthService } from '../../services/auth/auth.service';

@Pipe({
  name: 'userHasRole',
  standalone: true
})
export class UserHasRolePipe implements PipeTransform {

  constructor(
    private authService: AuthService,
  ) {
  }

  transform(value: UserRole[] | UserRole): boolean {
    return value instanceof Array ? this.authService.userHasRoles(value) : this.authService.userHasRole(value);
  }

}
